import { render, staticRenderFns } from "./QuestionMatrix.vue?vue&type=template&id=290e5267&scoped=true"
import script from "./QuestionMatrix.vue?vue&type=script&lang=js"
export * from "./QuestionMatrix.vue?vue&type=script&lang=js"
import style0 from "./QuestionMatrix.vue?vue&type=style&index=0&id=290e5267&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "290e5267",
  null
  
)

export default component.exports